import { useCallback, useState } from 'react';
import { toString } from 'lodash';

import {
  CreatePayoutDefinitionFormValues,
  CreatePayoutDefinitionPayload,
  PayoutDefinitionResponse,
} from '../CreatePayoutDefinitionModal.types';

interface UseCreatePayoutDefinitionSubmitParams {
  mutateAsync: (payload: CreatePayoutDefinitionPayload) => Promise<{ data?: PayoutDefinitionResponse }>;
  isLoading: boolean;
  onSuccess: (id: string) => void;
  onClose: () => void;
}

const useCreatePayoutDefinitionSubmit = ({
  mutateAsync,
  isLoading,
  onSuccess,
  onClose,
}: UseCreatePayoutDefinitionSubmitParams) => {
  const [isServerError, setServerError] = useState(false);

  const handleSubmit = useCallback(
    async (formValues: CreatePayoutDefinitionFormValues) => {
      try {
        const response = await mutateAsync({
          name: formValues.name.trim(),
          copyFromId: formValues.copyFromId || undefined,
        });

        const createdId = toString(response?.data?.id);
        onClose();
        onSuccess(createdId);
      } catch {
        setServerError(true);
      }
    },
    [mutateAsync, onClose, onSuccess]
  );

  return {
    handleSubmit,
    isLoading,
    isServerError,
    setServerError,
  };
};

export default useCreatePayoutDefinitionSubmit;
